module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jF6Tzt/tc-custom/9780369726384.jpg?1743854144023",
      "alt": "This image is the cover for the book Awakened by the Wild Billionaire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Awakened by the Wild Billionaire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("She’s shy. He’s "), _c('i', [_vm._v("wild")]), _vm._v("! Opposites attract in Bella Mason’s sexy debut romance for Harlequin Presents!")]), _c('br'), _c('br'), _vm._v(" A chance meeting…"), _c('br'), _c('i', [_vm._v("Leads to an extraordinary encounter")]), _c('br'), _c('br'), _vm._v(" Colliding with a masked stranger at a glamorous Melbourne ball sends shy Emma Brown’s pulse skyrocketing. And that’s "), _c('i', [_vm._v("before")]), _vm._v(" he introduces himself as Alexander Hastings, the ultrarich CEO with a wild side, which puts him way out of her league!"), _c('br'), _c('br'), _vm._v(" Only Alex’s focus is "), _c('i', [_vm._v("all")]), _vm._v(" on Emma. And just this once, she steps out of her family’s shadow and into the billionaire’s penthouse. Their unrivaled connection awakens in Emma a longing for the one thing she’s never allowed herself to want and the one thing Alex can’t offer her… Forever!"), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Presents:"), _c('i', [_vm._v(" Escape to exotic locations where passion knows no bounds.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bella Mason\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bella Mason has been a bookworm from an early age. She has been regaling people with stories from the time she discovered she could hold the dinner table hostage with her re-imagined fairy tales. After earning a degree in Journalism, she rekindled her love of writing and she now writes full time. When she isn't imagining dashing heroes and strong heroines, she can be found exploring Melbourne, with her nose in a book or lusting after fast cars. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0